import * as React from 'react';

const WebOrderDetails = () => {
  return (
    <div>
      <p>
        This licence provides access to ecCharts, which is ECMWF&apos;s interactive interface for visualising ECMWF real-time
        data (note: no raw data is accessible from this interface).
      </p>

      <p>
        Please note that access to all web products is provided on an &lsquo;as is&rsquo; basis. The product range is adjusted in
        the light of experience and in response to the evolution of the forecasting system; newly developed products are
        added, but others may be discontinued, at the discretion of ECMWF.
      </p>
    </div>
  )
}

export default WebOrderDetails;
